module.exports = __webpack_public_path__ + "img/20191101111307微信截图_20191101111357.186f57bc.png";